import { render, staticRenderFns } from "./FKomoditiImportExtDialog.vue?vue&type=template&id=085b581a&scoped=true"
import script from "./FKomoditiImportExtDialog.vue?vue&type=script&lang=js"
export * from "./FKomoditiImportExtDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085b581a",
  null
  
)

export default component.exports